"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NwcSeedbank_exports = {};
__export(NwcSeedbank_exports, {
  NwcSeedbank: () => NwcSeedbank
});
module.exports = __toCommonJS(NwcSeedbank_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_util = require("@cartographerio/util");
var import_core = require("../../core/index.js");
function speciesColor(species) {
  switch (species) {
    case "Betony":
      return "#be6ff7";
    case "BirdsfootTrefoil":
      return "#f7cffc";
    case "Bluebell":
      return "#646bf6";
    case "CommonCatsEar":
      return "#b1facf";
    case "CommonKnapweed":
      return "#ea3ef7";
    case "CornChamomile":
      return "#fffed1";
    case "CornMarigold":
      return "#fffd54";
    case "CornPoppy":
      return "#eb3223";
    case "CommonSorrel":
      return "#b8902f";
    case "Corncockle":
      return "#bb30c5";
    case "Cornflower":
      return "#3f99f7";
    case "CowParsley":
      return "#fffed1";
    case "DevilsBitScabious":
      return "#73fbfd";
    case "FieldScabious":
      return "#ed72c8";
    case "Foxglove":
      return "#eb4a97";
    case "GreaterBirdsfootTrefoil":
      return "#f8cd76";
    case "HedgeBedstraw":
      return "#b1f97b";
    case "LadysBedstraw":
      return "#eaeaea";
    case "MeadowButtercup":
      return "#f8cb46";
    case "Meadowsweet":
      return "#f7cecd";
    case "MuskMallow":
      return "#989bf8";
    case "OxeyeDaisy":
      return "#ffffff";
    case "PurpleLoosestrife":
      return "#5c1fc4";
    case "RaggedRobin":
      return "#be3f1e";
    case "RedCampion":
      return "#bb2965";
    case "RedClover":
      return "#8c3b64";
    case "RibwortPlantain":
      return "#8c3816";
    case "SelfHeal":
      return "#8b26c3";
    case "TuftedVetch":
      return "#0839c4";
    case "VipersBugloss":
      return "#5c1fc4";
    case "WildCarrot":
      return "#d5fda4";
    case "Yarrow":
      return "#c39a33";
    case "YellowFlagIris":
      return "#fefc7e";
    case "YellowRattle":
      return "#cbc942";
    case "Other":
      return "#ffcc00";
    default:
      return (0, import_util.checkExhausted)(species);
  }
}
const NwcSeedbank = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("NwcSeedbank"),
  title: "Wildflower Warriors",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("NwcSeedbank"),
      title: "Wildflower Warriors",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("NwcSeedbank"),
        attribution: []
      }),
      defaultAttribute: "collection",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Seed Collection",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "collection",
              label: "Seed Collection",
              enum: import_inventory_enums.NwcSeedbankCollectionEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Wildflower Species",
          attributes: import_inventory_enums.NwcSeedbankSpeciesEnum.entries.map(
            ({ value, label }) => (0, import_topo_map.booleanAttr)({
              attributeId: `species${value}`,
              label,
              buckets: [
                (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor(speciesColor(value)), "Yes (Species Observed)"),
                (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.empty, "No (Species Not Observed)")
              ]
            })
          )
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Area",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "area",
              label: "Approx Area",
              unit: "m2",
              enum: import_inventory_enums.NwcSeedbankAreaEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Land Use",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "dominantLandUse",
              label: "Dominant Land Use",
              enum: import_inventory_enums.NwcSeedbankLandUseEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Vegetation",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "dominantVegetation",
              label: "Dominant Vegetation",
              enum: import_inventory_enums.NwcSeedbankVegetationEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Soil Type",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "dominantSoilType",
              label: "Dominant Soil Type",
              enum: import_inventory_enums.NwcSeedbankSoilTypeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Problem Plant Species",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "problemPlantSpecies",
              label: "Problem Plant Species",
              enum: import_inventory_enums.NwcSeedbankProblemPlantSpeciesEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Wildlife Spotted",
          attributes: [
            (0, import_topo_map.booleanAttr)({
              attributeId: "wildlifeSpottedPollinators",
              label: "Pollinator Species",
              buckets: [
                (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor("#0f0"), "Present"),
                (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.fromColor("#aaa"), "Absent")
              ]
            }),
            (0, import_topo_map.booleanAttr)({
              attributeId: "wildlifeSpottedOther",
              label: "Other Wildlife Species",
              buckets: [
                (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor("#0f0"), "Present"),
                (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.fromColor("#aaa"), "Absent")
              ]
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  NwcSeedbank
});
//# sourceMappingURL=NwcSeedbank.js.map
